import { useState } from "react";
import { CreditCard, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

export const PayEnrollmentButton = ({ enrollmentId, amount, plan = "year", renew = false, label, className = "" }) => {
  const [busy, setBusy] = useState(false);
  const pay = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/courses/payments/checkout", { enrollment_id: enrollmentId, origin_url: window.location.origin, plan, renew });
      window.location.assign(data.url);
    } catch (err) {
      toast.error(apiError(err, "Paiement indisponible"));
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={pay} disabled={busy} data-testid="pay-enrollment-btn" className={`inline-flex items-center justify-center gap-2 bg-[color:var(--accent)] text-black font-semibold px-6 py-3 rounded-full text-xs uppercase tracking-widest hover:brightness-110 transition disabled:opacity-50 ${className}`}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />} {label || `Régler l'inscription annuelle · ${Number(amount).toFixed(0)} €`}
    </button>
  );
};
